import React, { useState, useEffect, useContext } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Typography,
  Input,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import UserForm from './UserForm';
import { Button } from '../ui/forms/Button';
import EnhancedTable from '../ui/Table/Enhanced/EnhancedTable';
import { UserContext } from '../../contexts/UserContext';
import SearchIcon from '@material-ui/icons/Search';

export const Users = () => {
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [createOpen, setCreateOpen] = useState(false);
  const [userToEdit, setUserToEdit] = useState();
  const [filterValue, setFilter] = useState('');
  const [filterColumn, setFilterColumn] = useState('email');
  const [columns] = useState([
    {
      id: 'id',
      disablePadding: false,
      label: 'ID',
    },
    {
      id: 'displayName',
      disablePadding: false,
      label: 'Name',
    },
    {
      id: 'email',
      disablePadding: false,
      label: 'Email',
    },
    {
      id: 'userType',
      disablePadding: false,
      label: 'User Type',
    },
    {
      id: 'currentSite',
      disablePadding: false,
      label: 'Current Site',
    },
    {
      id: 'action',
      disablePadding: false,
      label: 'Actions',
      align: 'right',
    },
  ]);
  const [rows, setRows] = useState([]);

  const { getAllUsers, deleteUser, getSearchUsers } = useContext(UserContext);

  const handleDialog = (dialog, data) => {
    if (dialog !== 'create' && !data) {
      setDeleteOpen(false);
      setCreateOpen(false);
      setEditOpen(false);
      setUserToEdit(null);
      return;
    }
    if (dialog === 'create') {
      setCreateOpen(true);
      setUserToEdit(null);
    } else if (dialog === 'delete') {
      setUserToEdit(data);
      setDeleteOpen(true);
    } else {
      setUserToEdit(data);
      setEditOpen(true);
    }
  };

  const handleDelete = () => {
    if (userToEdit) {
      deleteUser(userToEdit.id).then(() => {
        setDeleteOpen(false);
        refreshUsers();
      });
    }
  };

  const refreshUsers = () => {
    getAllUsers()
      .then((users) => {
        let rowData = [];
        users.forEach((user) => {
          rowData.push({
            key: user.id,
            id: user.id,
            displayName: user.displayName,
            email: user.email,
            userType:
              user.userRole === 'admin' ? (
                <Typography color='error' variant='button'>
                  Admin
                </Typography>
              ) : (
                <Typography variant='button'>User</Typography>
              ),
            currentSite: user.currentSite,
            action: (
              <>
                <Button
                  colour='info'
                  onClick={() =>
                    handleDialog('edit', {
                      id: user.id,
                      userRole: user.userRole,
                      displayName: user.displayName,
                      email: user.email,
                      telephone: user.telephone,
                      position: user.position,
                      showCampaigns: user.showCampaigns,
                      sites: [],
                    })
                  }
                  margin='0 1rem 0 0'
                >
                  Edit
                </Button>
                <Button
                  colour='error'
                  disabled={user.userRole === 'admin'}
                  onClick={() => handleDialog('delete', user)}
                >
                  Delete
                </Button>
              </>
            ),
          });
        });
        setRows(rowData);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    refreshUsers();
    //eslint-disable-next-line
  }, []);

  const searchData = async () => {
    getSearchUsers(filterColumn, filterValue)
      .then((users) => {
        let rowData = [];
        users.forEach((user) => {
          rowData.push({
            key: user.id,
            id: user.id,
            displayName: user.displayName,
            email: user.email,
            userType:
              user.userRole === 'admin' ? (
                <Typography color='error' variant='button'>
                  Admin
                </Typography>
              ) : (
                <Typography variant='button'>User</Typography>
              ),
            currentSite: user.currentSite,
            action: (
              <>
                <Button
                  colour='info'
                  onClick={() =>
                    handleDialog('edit', {
                      id: user.id,
                      userRole: user.userRole,
                      displayName: user.displayName,
                      email: user.email,
                      telephone: user.telephone,
                      position: user.position,
                      sites: [],
                    })
                  }
                  margin='0 1rem 0 0'
                >
                  Edit
                </Button>
                <Button
                  colour='error'
                  disabled={user.userRole === 'admin'}
                  onClick={() => handleDialog('delete', user)}
                >
                  Delete
                </Button>
              </>
            ),
          });
        });
        setRows(rowData);
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <button
        onClick={searchData}
        style={{ float: 'right', backgroundColor: '#2E3652' }}
      >
        <SearchIcon />
      </button>
      <Input
        style={{ float: 'right', backgroundColor: '#2E3652' }}
        value={filterValue || ''}
        onChange={(e) => {
          setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
        }}
        placeholder={`Search with Email`}
      />
      <EnhancedTable
        rows={rows}
        columns={columns}
        title={
          <Button
            colour='success'
            onClick={() => handleDialog('create', null)}
            startIcon={<AddIcon />}
          >
            Create User
          </Button>
        }
        colour='error'
      />
      <Dialog open={deleteOpen} onClose={() => handleDialog()} maxWidth='md'>
        <DialogTitle>Delete User</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this user?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteOpen(false)}>Cancel</Button>
          <Button colour='error' onClick={handleDelete}>
            Proceed
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={editOpen} onClose={() => handleDialog()}>
        <DialogTitle>Edit User</DialogTitle>
        <DialogContent>
          <UserForm
            user={userToEdit}
            close={() => handleDialog()}
            refresh={refreshUsers}
          />
        </DialogContent>
      </Dialog>

      <Dialog open={createOpen} onClose={() => handleDialog()}>
        <DialogTitle>Create User</DialogTitle>
        <DialogContent>
          <UserForm close={() => handleDialog()} refresh={refreshUsers} />
        </DialogContent>
      </Dialog>
    </>
  );
};
